module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0130.jpg?v=6e75b53e";